import React from 'react';
import { observer } from 'mobx-react-lite';
import { useDependencies } from '@servicetitan/react-ioc';
import { ServiceFinanceStore } from '../../../../stores/service-finance.store';
import { PrimaryApplicant } from './primary-applicant';
import { ApplicantMaritalStatus } from './applicant-marital-status';
import { CitizenshipInformation } from './citizenship-information';
import { ResidenceInformation } from './residence-information';
import { WorkingAddress } from './working-address';
import styles from './add-info-page.less';
import { Stack } from '@servicetitan/design-system';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

export const AddInfoPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    const loan = store.applicationForm!.$.Loan;
    const desiredLoanAmount =
        loan.$.SalesAmount.value && loan.$.DownPayment.value
            ? parseFloat(loan.$.SalesAmount.value) - parseFloat(loan.$.DownPayment.value)
            : 0;

    return (
        <React.Fragment>
            <Stack direction="column" justifyContent="flex-start" className="m-y-2 page-content">
                <Stack.Item>
                    <div className={styles.title}>Loan Information</div>
                    <div className={styles.subTitle}>Desired Loan Amount</div>
                    <div className={styles.amount}>${desiredLoanAmount}</div>
                    <div className={styles.title}>Applicant Information</div>
                </Stack.Item>
                <Stack.Item>
                    <PrimaryApplicant
                        applicant={store.applicationForm!.$.PrimaryApplicant}
                        states={store.getStates()}
                        validate={store.validateField}
                    />
                    {store.isMaritalStatusRequired && (
                        <ApplicantMaritalStatus
                            marriage={store.applicationForm!.$.Marriage}
                            validate={store.validateField}
                        />
                    )}
                    <CitizenshipInformation
                        personalInfo={store.applicationForm!.$.PrimaryApplicant.$.PersonalInfo}
                    />
                    <ResidenceInformation
                        residence={store.applicationForm!.$.Residence}
                        validate={store.validateField}
                    />
                    <WorkingAddress
                        homeAddress={store.applicationForm!.$.PrimaryApplicant.$.HomeAddress}
                        workingAddress={store.applicationForm!.$.WorkingAddress}
                        workingAddressSameAsPrimaryAddress={
                            store.applicationForm!.$.WorkingAddressSameAsPrimaryAddress
                        }
                        states={store.getStates()}
                        validate={store.validateField}
                    />
                    <div className={styles.sectionTitle}>Co-Applicant? *</div>
                    <div className={styles.radioRow}>
                        <RadioGroup
                            row
                            value={store.isCoApplicantSelectedMobile.toString()}
                            onChange={(e, val) =>
                                store.setIsCoApplicantSelectedMobile(JSON.parse(val))
                            }
                        >
                            <FormControlLabel
                                className={styles.radioLabel}
                                value="true"
                                control={<Radio className={styles.radio} />}
                                label="Yes"
                            />
                            <FormControlLabel
                                className={styles.radioLabel}
                                value="false"
                                control={<Radio className={styles.radio} />}
                                label="No"
                            />
                        </RadioGroup>
                    </div>
                </Stack.Item>
            </Stack>
        </React.Fragment>
    );
});
